import React from 'react';
import { useTranslation } from 'react-i18next';
import InstrumentRowContainer from '@alphapoint/apex-web/lib/components/InstrumentRow';
import PriceChartContainer from '@alphapoint/apex-web/lib/components/PriceChart/PriceChartContainer';
import DepthChartContainer from '@alphapoint/apex-web/lib/components/DepthChart/DepthChartContainer';
import OrderBookContainer from '@alphapoint/apex-web/lib/components/OrderBookComponents/OrderBookContainer';
import RecentTradesContainer from '@alphapoint/apex-web/lib/components/RecentTrades/RecentTradesContainer';
import { getBEMClasses } from '@alphapoint/apex-web/lib/helpers/cssClassesHelper';

import './SimpleExchangePage.css';

const exchangePageClasses = getBEMClasses('simple-exchange-page');

const SimpleExchangePage = () => {
  const { t } = useTranslation();

  return (
    <div className={exchangePageClasses('container')}>
      <div className={exchangePageClasses('row')}>
        <InstrumentRowContainer />
      </div>
      <div className={exchangePageClasses('body')}>
        <div className={exchangePageClasses('chart-container')}>
          <div className={exchangePageClasses('chart-header')}>{t('Price Chart')}</div>
          <PriceChartContainer />
          <DepthChartContainer />
        </div>
        <div className={exchangePageClasses('column-container')}>
          <div className={exchangePageClasses('title')}>{t('Order Book')}</div>
          <OrderBookContainer />
        </div>

        <div className={exchangePageClasses('column-container')}>
          <div className={exchangePageClasses('title')}>{t('Recent Trades')}</div>
          <RecentTradesContainer />
        </div>
      </div>
    </div>
  );
};

export default SimpleExchangePage;
